import _classCallCheck from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/codebuild/output/src2105143893/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { decode } from 'he';
import Node from './node';
import NodeType from './type';
/**
 * TextNode to contain a text element in DOM tree.
 * @param {string} value [description]
 */

var TextNode = /*#__PURE__*/function (_Node) {
  _inherits(TextNode, _Node);

  var _super = _createSuper(TextNode);

  function TextNode(rawText, parentNode, range) {
    var _this;

    _classCallCheck(this, TextNode);

    _this = _super.call(this, parentNode, range);
    /**
     * Node Type declaration.
     * @type {Number}
     */

    _this.nodeType = NodeType.TEXT_NODE;
    _this._rawText = rawText;
    return _this;
  }

  _createClass(TextNode, [{
    key: "rawText",
    get: function get() {
      return this._rawText;
    }
    /**
     * Set rawText and invalidate trimmed caches
     */
    ,
    set: function set(text) {
      this._rawText = text;
      this._trimmedRawText = void 0;
      this._trimmedText = void 0;
    }
    /**
     * Returns raw text with all whitespace trimmed except single leading/trailing non-breaking space
     */

  }, {
    key: "trimmedRawText",
    get: function get() {
      if (this._trimmedRawText !== undefined) return this._trimmedRawText;
      this._trimmedRawText = trimText(this.rawText);
      return this._trimmedRawText;
    }
    /**
     * Returns text with all whitespace trimmed except single leading/trailing non-breaking space
     */

  }, {
    key: "trimmedText",
    get: function get() {
      if (this._trimmedText !== undefined) return this._trimmedText;
      this._trimmedText = trimText(this.text);
      return this._trimmedText;
    }
    /**
     * Get unescaped text value of current node and its children.
     * @return {string} text content
     */

  }, {
    key: "text",
    get: function get() {
      return decode(this.rawText);
    }
    /**
     * Detect if the node contains only white space.
     * @return {boolean}
     */

  }, {
    key: "isWhitespace",
    get: function get() {
      return /^(\s|&nbsp;)*$/.test(this.rawText);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.rawText;
    }
  }]);

  return TextNode;
}(Node);
/**
 * Trim whitespace except single leading/trailing non-breaking space
 */


export { TextNode as default };

function trimText(text) {
  var i = 0;
  var startPos;
  var endPos;

  while (i >= 0 && i < text.length) {
    if (/\S/.test(text[i])) {
      if (startPos === undefined) {
        startPos = i;
        i = text.length;
      } else {
        endPos = i;
        i = void 0;
      }
    }

    if (startPos === undefined) i++;else i--;
  }

  if (startPos === undefined) startPos = 0;
  if (endPos === undefined) endPos = text.length - 1;
  var hasLeadingSpace = startPos > 0 && /[^\S\r\n]/.test(text[startPos - 1]);
  var hasTrailingSpace = endPos < text.length - 1 && /[^\S\r\n]/.test(text[endPos + 1]);
  return (hasLeadingSpace ? ' ' : '') + text.slice(startPos, endPos + 1) + (hasTrailingSpace ? ' ' : '');
}